/* NORDIC BEARS theme JS (Early Access): navigation only. No cart, no checkout. */
(function(){'use strict';
document.addEventListener('click',function(e){var t=e.target.closest('[data-menu]');if(!t)return;var n=document.getElementById('nav');if(!n)return;var o=n.classList.toggle('open');t.setAttribute('aria-expanded',o)});
document.addEventListener('change',function(e){if(e.target.matches&&e.target.matches('[data-country-select]'))e.target.form.submit()});
})();
